export default {
  login: {
    method: 'post',
    url: '/tenant/login',
    desc: '登录接口'
  },
  gylLogin: {
    method: 'post',
    url: '/tenant/supplier/login',
    desc: '供应链登录接口'
  },
  updatePwd: {
    method: 'post',
    url: 'tenant/updatePwd',
    desc: '修改密码'
  },
  logout: {
    method: 'post',
    url: '/tenant/logout',
    desc: '登出'
  },
  code: {
    method: 'post',
    url: '/aaa/code',
    desc: '授权'
  },
  auth: {
    method: 'post',
    url: '/aaa/auth',
    desc: '授权回调'
  },
  shopeeCode: {
    method: 'post',
    url: '/shopee/code',
    desc: '虾皮授权'
  },
  shopeeAuth: {
    method: 'post',
    url: '/shopee/auth',
    desc: '虾皮授权回调'
  },
  getUserInfo: {
    method: 'post',
    url: '/tenant/getUserInfo',
    desc: '获取个人信息'
  },
  syncMenuRight: {
    method: 'get',
    url: '/shop/syncMenuRight',
    desc: '获取北京菜单'
  },
  fbaMenuUserApi: {
    method: 'get',
    url: '/shop/fbaMenuUserApi',
    desc: 'fba账户'
  },
  getPageFunctionalRights: {
    method: 'get',
    url: '/shop/getPageFunctionalRights',
    desc: '获取当前页面按钮权限'
  },
  createQrCode: {
    method: 'get',
    url: '/weixin/createQrCode',
    desc: '系统获取关注绑定二维码信息'
  },
  getBindStatus: {
    method: 'post',
    url: '/weixin/getBindStatus',
    desc: '查询绑定状态'
  },
  removeBind: {
    method: 'post',
    url: '/weixin/removeBind',
    desc: '解除绑定'
  },
  acquireNoticeInfo: {
    method: 'get',
    url: '/shop/acquireNoticeInfo',
    desc: '获取公告信息'
  },
  closeNotice: {
    method: 'get',
    url: '/shop/closeNotice',
    desc: '关闭公告'
  },
  queryAuthCode: {
    method: 'post',
    url: '/sys/clew/code',
    desc: '获取验证码'
  },
  registry: {
    method: 'post',
    url: '/sys/clew/add',
    desc: '注册接口'
  },
}
